import React from 'react';
import PropTypes from 'prop-types';
import { Slide } from 'investira.react.components';

/**
 * Renderiza o componente Transition.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.direction - Propriedade `direction` do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction={props.direction} ref={ref} {...props} />;
});

Transition.propTypes = {
    direction: PropTypes.string
};

Transition.defaultProps = {
    direction: 'up'
};

export default Transition;
